<template>
  <div>
    <div class="row align-items-baseline">
      <div class="col-10">
        <ArtistDetails
          v-if="internetAuction.artwork.artist"
          class="headings--h2 artwork__header"
          :artist="internetAuction.artwork.artist"
        />
        <div
          v-else
          class="headings--h2 artwork__header"
        >
          {{ internetAuction.artwork.name }}
        </div>
      </div>
      <div class="col-2 text-right">
        <ArtworkMemorise
          :artwork="internetAuction.artwork"
          :modal="true"
          @handleMemoriseResponse="changeArtworkMemoriseState"
        />
      </div>
    </div>
    <div class="details__art-desc mb-4">
      <h4 v-if="internetAuction.artwork.artist">
        {{ internetAuction.artwork.name }}
      </h4>
      <p v-html="internetAuction.artwork.description"></p>
    </div>
    <InternetAuctionCountdown
      v-if="internetAuction.state === 'started'"
      class="internet-modal__countdown d-flex justify-content-lg-between align-items-center"
      :time-to-calculate="{
        endDate: internetAuction.endDate,
        type: 'modal',
        isOvertime: internetAuction.isOvertime,
      }"
    />
    <div
      v-if="internetAuctionSold"
      class="mb-2 mb-xl-0"
    >
      <p class="title d-flex align-items-center internet-modal__sold">
        {{ I18n.t("internet_auctions.auction.sold") }}
        <span class="internet_auction-offers price--highlight ml-1">
          {{ I18n.t("internet_auctions.auction.number_of_offers", { count: internetAuction.bidsCount }) }}
        </span>
      </p>
      <p class="price price--highlight">
        {{ I18n.t("artworks.price", { price: formatPrice(internetAuction.value) }) }}
      </p>
    </div>
    <div
      v-if="internetAuctionUnsold"
      class="internet-modal__unsold-btn d-inline-block"
    >
      {{ I18n.t("internet_auctions.auction.unsold") }}
    </div>
    <hr
      v-if="internetAuction.state !== 'pending'"
      class="internet-modal__line mt-2"
    >
    <div class="artwork__table-data">
      <ArtworkPriceDetails :internetAuction="internetAuction" />
      <AuctionValue :internetAuction="internetAuction" />
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import { formatNumber } from '@/shared/helpers';
  import ArtistDetails from '@/shared/components/artist_details';
  import ArtworkMemorise from '@/shared/components/artwork_memorise';
  import InternetAuctionCountdown from '@/internet_auctions/components/internet_auction_countdown';
  import AuctionValue from './auction_value';
  import ArtworkPriceDetails from './artwork_price_details';

  export default {
    name: 'ArtworkDetails',
    components: {
      ArtistDetails,
      AuctionValue,
      InternetAuctionCountdown,
      ArtworkPriceDetails,
      ArtworkMemorise,
    },
    props: {
      internetAuction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    methods: {
      ...mapMutations(['SET_MEMORISE_STATE']),
      changeArtworkMemoriseState(artworkId) {
        this.SET_MEMORISE_STATE(artworkId);
      },
    },
    computed: {
      internetAuctionSold() {
        return this.internetAuction.state === 'sold';
      },
      internetAuctionUnsold() {
        return this.internetAuction.state === 'unsold';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/modal/artwork_details.vue?326c3e38